import { useTranslation } from "react-i18next";
import Input from "../../Atoms/Input";
import React, { useRef } from "react";
import { useState } from "react";
import BlueButton from "../../Atoms/BlueButton";
import Select from "../../Atoms/Select";
import Popup from "../../Atoms/Popup";
import Textarea from "../../Atoms/Textarea";
import AwardsDisplay from "../../Atoms/AwardsDisplay";
import AwardsAdd from "../../Atoms/AwardsAdd";
import BoldBlue from "../../Atoms/BoldBlue";
import CheckboxPublicPrivate from "../../Atoms/CheckboxPublicPrivate";
import Checkbox from "../../Atoms/Checkbox";
import styled from "styled-components";
import { FD100MultiSelectOptions } from "../../Utils/Listings";
import MiniatureContainer from "../../Atoms/MiniatureContainer";
import PressLinksDisplay from "../../Atoms/PressLinksDisplay";
import PressLinksAdd from "../../Atoms/PressLinksAdd";
import FabricantsDisplay from "../../Atoms/FabricantsDisplay";
import FabricantsAdd from "../../Atoms/FabricantsAdd";
import AdressInput from "../../Atoms/AdressInput";
import * as api from '../../../api';

const ProjectLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
`;

const Step2 = (props) => {
    const { i18n } = useTranslation('common');

    //listings
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100(i18n.language);
    const typologieAssiseFD100 = FD100MultiSelectOptions.typologieAssiseFD100(i18n.language);
    const typologieTableFD100 = FD100MultiSelectOptions.typologieTableFD100(i18n.language);
    const typologieLuminaireFD100 = FD100MultiSelectOptions.typologieLuminaireFD100(i18n.language);
    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100(i18n.language);

    // stuff for the "add from portfolio" popup
    const [addProjectFromPortfolioPopupOpen, setAddProjectFromPortfolioPopupOpen] = useState(false);
    const [selectedProjectToAdd, setSelectedProjectToAdd] = useState("");
    //on popup close, reset selected project
    React.useEffect(() => {
        if (!addProjectFromPortfolioPopupOpen) {
            setSelectedProjectToAdd("");
        }
    }, [addProjectFromPortfolioPopupOpen]);

    React.useEffect(() => {
        // if there is a addprojectfromportfolio=true, set the step to 2
        const addProjectFromPortfolio = new URLSearchParams(window.location.search).get("addprojectfromportfolio");
        if (addProjectFromPortfolio) {
            setAddProjectFromPortfolioPopupOpen(true);
            //remove the addprojectfromportfolio from the url
            const url = new URL(window.location.href);
            url.searchParams.delete("addprojectfromportfolio");
            window.history.replaceState({}, document.title, url);
        }
    }, []);

    //when props.projets changes, check that there is a id_in_participation, and if not, set it to a random string
    React.useEffect(() => {
        props.projets.forEach((project) => {
            if (!project.id_in_participation) {
                project.id_in_participation = Math.random().toString(36).substring(2);
            }
        });
    }, [props.projets]);

    //stuff for the edit/create project popup
    const [currentlyEditingProject, setCurrentlyEditingProject] = useState(null);
    const [awards, setAwards] = useState(""); //awards is a json string
    const [pressLinks, setPressLinks] = useState(""); //pressLinks is a json string
    const [fabricants, setFabricants] = useState(""); //fabricants is a json string
    const [type, setType] = useState("");
    const [fabrication_fr, setFabrication_fr] = useState("");
    const [typologie, setTypologie] = useState("");
    const [mediasToDelete, setMediasToDelete] = useState([]);
    const [newMedias, setNewMedias] = useState([]);
    //when the popup is opened, set states to the default values
    React.useEffect(() => {
        if (currentlyEditingProject) {
            setAwards(currentlyEditingProject.awards || "");
            setPressLinks(currentlyEditingProject.lien_presse || "");
            setFabricants(currentlyEditingProject.fabricants || "");
            setType(currentlyEditingProject.type || "");
            setFabrication_fr(currentlyEditingProject.fabrication_fr || "");
            setTypologie(currentlyEditingProject.typologie || "");
            setMediasToDelete(currentlyEditingProject.mediasToDelete || []);
            setNewMedias(currentlyEditingProject.newMedias || []);

            //first, convert the year to a number. if currentlyEditingProject.year is below 2024 or above 2036, set it to 2024
            let year = parseInt(currentlyEditingProject.year);
            if (year < 2024 || year > 2036) {
                year = 2024;
                //then, set the year to the number
                setCurrentlyEditingProject({...currentlyEditingProject, year: year.toString()});
            }
        }
    }, [currentlyEditingProject]);
    //when typologie changes, reset the subtypologie if the current one is not in the new list
    React.useEffect(() => {
        if(type === "objet") {
            if (!typologieObjetFD100.find((option) => option.value === typologie)) {
                setTypologie(typologieObjetFD100[0].value);
            }
        } else {
            if (!tyoplogieEspaceFD100.find((option) => option.value === typologie)) {
                setTypologie(tyoplogieEspaceFD100[0].value);
            }
        }
    }, [type]);
    function removeNewMedia(media){
        setNewMedias(newMedias.filter((_media) => _media !== media));
    }
    function removeOldMedia(media){
        setCurrentlyEditingProject({...currentlyEditingProject, medias:currentlyEditingProject.medias.filter((_media) => _media !== media)});
        setMediasToDelete([...mediasToDelete, media.path]);
    }
    function commitCurrentProject() {

        //get the field values
        const divContainingTheFields = document.querySelector(".currentlyEditingProjectPopupInner");

        const fields = Array.from(divContainingTheFields.querySelectorAll("input, textarea, select"));
        const name = fields.find((field) => field.name === "nom_projet")?.value;
        const name_en = fields.find((field) => field.name === "nom_projet_en")?.value;
        const description_francais = fields.find((field) => field.name === "description_francais")?.value;
        const description_anglais = fields.find((field) => field.name === "description_anglais")?.value;
        const project_public = fields.find((field) => field.name === "public").checked;
        const autorisation = fields.find((field) => field.name === "autorisation").checked;
        const annee_projet = fields.find((field) => field.name === "annee_projet")?.value;
        const type = fields.find((field) => field.name === "type")?.value;
        const unique_collection = fields.find((field) => field.name === "unique_collection")?.value;
        const typologie = fields.find((field) => field.name === "typologie")?.value;
        const typologieAssise = fields.find((field) => field.name === "typologieAssise")?.value;
        const typologieTable = fields.find((field) => field.name === "typologieTable")?.value;
        const typologieLuminaire = fields.find((field) => field.name === "typologieLuminaire")?.value;
        const autre_typologie = fields.find((field) => field.name === "autre_typologie")?.value;
        const adresse = fields.find((field) => field.name === "adresse")?.value;
        const fabrication_fr = fields.find((field) => field.name === "fabrication_fr")?.value;
        const communiquer_fabricants = fields.find((field) => field.name === "communiquer_fabricants")?.value;
        const editeur = fields.find((field) => field.name === "editeur")?.value;
        const distributeur = fields.find((field) => field.name === "distributeur")?.value;
        const pays_distribution = fields.find((field) => field.name === "pays_distribution")?.value;
        const echelle_production = fields.find((field) => field.name === "echelle_production")?.value;
        const id_in_participation = fields.find((field) => field.name === "id_in_participation")?.value;
        const id_in_company = fields.find((field) => field.name === "id_in_company")?.value;
        const latitude = fields.find((field) => field.name === "latitude")?.value;
        const longitude = fields.find((field) => field.name === "longitude")?.value;

        api.LogFront("FD1002025 commitCurrentProject with title : "+name+" and id_in_participation : "+id_in_participation);

        //check that autorisation is checked
        if (!autorisation) {
            // alert("Veuillez certifier avoir l'autorisation de communiquer sur le projet au moment de la révélation du prix");
            alert(i18n.language === "fr" ? "Veuillez certifier avoir l'autorisation de communiquer sur le projet au moment de la révélation du prix" : "Please certify that you have permission to communicate about the project at the time of the prize reveal");
            return;
        }

        //check that the required fields are filled
        // if (!name || !description_francais || !description_anglais || !annee_projet || !type || !typologie || !fabrication_fr) {
        //     alert("Veuillez remplir tous les champs obligatoires");
        //     return;
        // }

        if(!name){
            alert(i18n.language === "fr" ? "Veuillez renseigner le nom du projet" : "Please fill in the project name");
            return;
        }

        if(!description_francais){
            alert(i18n.language === "fr" ? "Veuillez remplir la description du projet en français" : "Please fill in the project description in French");
            return;
        }

        if(!description_anglais){
            alert(i18n.language === "fr" ? "Veuillez remplir la description du projet en anglais" : "Please fill in the project description in English");
            return;
        }

        if(!annee_projet){
            alert(i18n.language === "fr" ? "Veuillez renseigner l'année du projet" : "Please fill in the project year");
            return;
        }

        if(!type){
            alert(i18n.language === "fr" ? "Veuillez renseigner le type de projet" : "Please fill in the project type");
            return;
        }

        if(!typologie){
            alert(i18n.language === "fr" ? "Veuillez renseigner la typologie du projet" : "Please fill in the project typology");
            return;
        }

        //check that the required fields are filled for the type "objet"
        // if (type === "objet" && (!editeur || !distributeur || !pays_distribution || !unique_collection || !echelle_production)) {
        //     alert("Veuillez remplir tous les champs obligatoires");
        //     return;
        // }

        if(type === "objet"){
            if(!editeur){
                alert(i18n.language === "fr" ? "Veuillez renseigner l'éditeur" : "Please fill in the editor");
                return;
            }

            if(!distributeur){
                alert(i18n.language === "fr" ? "Veuillez renseigner le distributeur" : "Please fill in the distributor");
                return;
            }

            if(!pays_distribution){
                alert(i18n.language === "fr" ? "Veuillez renseigner le pays de distribution" : "Please fill in the distribution country");
                return;
            }

            if(!unique_collection){
                alert(i18n.language === "fr" ? "Veuillez renseigner s'il s'agit d'une pièce unique ou d'une collection" : "Please fill in whether it is a single piece or a collection");
                return;
            }

            if(!echelle_production){
                alert(i18n.language === "fr" ? "Veuillez renseigner l'échelle de production" : "Please fill in the production scale");
                return;
            }
        }

        //check that the required fields are filled for the typologie "assise"
        if (typologie === "assise" && !typologieAssise) {
            alert(i18n.language === "fr" ? "Veuillez rensigner le type d'assise" : "Please fill in the seating type");
            return;
        }

        //check that the required fields are filled for the typologie "table"
        if (typologie === "table" && !typologieTable) {
            alert(i18n.language === "fr" ? "Veuillez rensigner le type de table" : "Please fill in the table type");
            return;
        }

        //check that the required fields are filled for the typologie "luminaire"
        if (typologie === "luminaire" && !typologieLuminaire) {
            alert(i18n.language === "fr" ? "Veuillez rensigner le type de luminaire" : "Please fill in the luminaire type");
            return;
        }

        //check that the required fields are filled for the type "espace"
        if (type === "espace") {
            //check that the required fields are filled for the type "espace"
            if (!adresse) {
                alert(i18n.language === "fr" ? "Veuillez rensigner l'adresse" : "Please fill in the address");
                return;
            }

            //check that the adress doesnt end with , France
            if (adresse.endsWith(", France")) {
                alert(i18n.language === "fr" ? "Les projets situés en France ne sont pas éligibles à l'appel à projet." : "Projects located in France are not eligible for the call for projects");
                return;
            }
        }

        //if fabricants are shown, check that at least one is added
        if (shouldAddFabricants() && (!fabricants || JSON.parse(fabricants).length === 0)) {
            alert("Veuillez ajouter au moins un fabricant");
            return;
        }

        //check that there are at least 3 medias
        const oldMediasCount = currentlyEditingProject?.medias?.length || 0;
        const newMediasCount = newMedias.length;

        const minimumMediasCount = type === "objet" ? 5 : 8;

        if (oldMediasCount + newMediasCount < minimumMediasCount) {
            alert("Veuillez ajouter au moins "+minimumMediasCount+" médias");
            return;
        }

        //commit the current project to the projets array
        const newProject = {
            name,
            name_en,
            aboutfr: description_francais,
            abouten: description_anglais,
            awards,
            lien_presse: pressLinks,
            fabricants,
            public: project_public,
            autorisation,
            year: annee_projet,
            type,
            unique_collection,
            typologie,
            typologieAssise,
            typologieTable,
            typologieLuminaire,
            autre_typologie,
            adresse,
            fabrication_fr,
            communiquer_fabricants,
            editeur,
            distributeur,
            pays_distribution,
            echelle_production,
            id_in_participation,
            id_in_company,
            medias: currentlyEditingProject?.medias || [],
            newMedias,
            mediasToDelete,
            latitude,
            longitude
        }

        console.log("newProject", newProject);

        //if we are editing an existing project (id_in_participation), replace it in the array
        if (currentlyEditingProject.id_in_participation && props.projets.find((project) => project.id_in_participation === currentlyEditingProject.id_in_participation)) {
            console.log("currentlyEditingProject.id_in_participation", currentlyEditingProject.id_in_participation);
            
            const _projects = [...props.projets];
            const index = _projects.findIndex((project) => project.id_in_participation === currentlyEditingProject.id_in_participation);
            _projects[index] = newProject;
            props.setProjets(_projects);
        } else {

            console.log("no currentlyEditingProject.id_in_participation");

            //if we are creating a new project, generate a new id_in_participation and add it to the array
            newProject.id_in_participation = Math.random().toString(36).substring(2);

            console.log("newProject.id_in_participation : ", newProject.id_in_participation);

            props.setProjets([...props.projets, newProject]);
        }

        //close the popup
        setCurrentlyEditingProject(null);
    }


    const projectsInUsersPortfolio = props.fullUser?.company?.projects || [];

    console.log("props.projets");
    console.log(props.projets);

    //fabricants are required either if the project is of type object, or if its of type espace and uses fab fr
    const shouldAddFabricants = () => type === "objet" || (type === "espace" && fabrication_fr === "oui");

    return (<>
        <h2 className="formtitle" style={{ marginBottom: '20px'}}>{i18n.language === "fr" ? "Vos projets" : "Your projects"}</h2>
        {props.projets.map((project) => 
            <ProjectLine key={project.id_in_participation}>
                <span>{project.name}</span>
                <div style={{display:"flex", gap:"10px"}}>
                    <BlueButton type="button" onClick={()=>setCurrentlyEditingProject(project)}>
                        {i18n.language === "fr" ? "Modifier" : "Edit"}
                    </BlueButton>
                    <BlueButton type="button" onClick={()=>{
                        if (window.confirm(i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer ce projet ?" : "Are you sure you want to delete this project?")) {
                            props.setDeletedProjets([...props.deletedProjets, project.id_in_participation]);
                            props.setProjets(props.projets.filter((p) => p.id_in_participation !== project.id_in_participation));
                        }
                    }}>
                        {i18n.language === "fr" ? "Supprimer" : "Delete"}
                    </BlueButton>
                </div>
            </ProjectLine>
        )}
        <div className="flexblock">
            <BlueButton type="button" style={{padding:"12px 20px"}} onClick={()=>setAddProjectFromPortfolioPopupOpen(true)}>
                {i18n.language === "fr" ? "Ajouter un projet de votre portfolio" : "Add a project from your portfolio"}
            </BlueButton>
            <BlueButton type="button" style={{padding:"12px 20px"}} onClick={()=>setCurrentlyEditingProject({})}>
                {i18n.language === "fr" ? "Ajouter un nouveau projet" : "Add a new project"}
            </BlueButton>
        </div>
        <br/>
        <div className="centered">
            {i18n.language === "fr" ? "Les modifications et les ajouts que vous apportez à vos projets seront répercutées sur votre portfolio une fois que vous aurez cliqué sur le bouton 'Enregistrer'." : "The changes you make to your projects will be reflected on your portfolio once you click the 'Save' button."}
        </div>
        {addProjectFromPortfolioPopupOpen &&
            <Popup close={()=>setAddProjectFromPortfolioPopupOpen(false)}>
                <h2 className='centered'>{i18n.language === "fr" ? "Sélectionnez un projet" : "Select a project"}</h2>
                <br/>
                {projectsInUsersPortfolio.length > 0 ?
                    <Select style={{width:"100%"}} onChange={(e)=>setSelectedProjectToAdd(e.target.value)}>
                        <option value="">{i18n.language === "fr" ? "Sélectionnez un projet à ajouter" : "Select a project to add"}</option>
                        {projectsInUsersPortfolio.filter((project) => !props.projets.find((p) => p.id_in_company === project._id)).map((project) => {
                            return <option key={project._id} value={project._id}>{project.name}</option>
                        })}
                    </Select>
                :
                    <p>{i18n.language === "fr" ? "Vous n'avez pas de projets dans votre portfolio." : "You don't have any projects in your portfolio."}</p>
                }
                <br/>
                {selectedProjectToAdd ?
                    <BlueButton type="button" onClick={()=>{
                        setCurrentlyEditingProject(projectsInUsersPortfolio.find((project)=>project._id === selectedProjectToAdd));
                        setAddProjectFromPortfolioPopupOpen(false);
                    }}>
                        {i18n.language === "fr" ? "Ajouter" : "Add"}
                    </BlueButton>
                : 
                    <BlueButton type="button" onClick={()=>setAddProjectFromPortfolioPopupOpen(false)}>
                        {i18n.language === "fr" ? "Fermer" : "Close"}
                    </BlueButton>
                }
            </Popup>
        }
        {currentlyEditingProject &&
            <Popup style={{maxWidth:"calc(min(100vw,800px) - 20px)",padding:"32px 0"}} close={()=>setCurrentlyEditingProject(null)}>
                <div style={{overflow:"scroll", maxHeight:"calc(100vh - 20px)", width:"100%",padding:"0 32px"}} className="currentlyEditingProjectPopupInner">
                    <BoldBlue>{i18n.language === "fr" ? "Nom du projet en français*" : "Project name in French*"}</BoldBlue>
                    <Input required name="nom_projet" style={{width:'100%',fontSize:'35px',fontWeight:'600'}} placeholder={i18n.language === "fr" ? "Nom du projet en français" : "Project name in French"} defaultValue={currentlyEditingProject?.name} />
                    <br/><br/>
                    <BoldBlue>{i18n.language === "fr" ? "Nom du projet en anglais*" : "Project name in English*"}</BoldBlue>
                    <Input required name="nom_projet_en" style={{width:'100%',fontSize:'35px',fontWeight:'600'}} placeholder={i18n.language === "fr" ? "Nom du projet en anglais" : "Project name in English"} defaultValue={currentlyEditingProject?.name_en} />
                    <br/><br/>
                    <BoldBlue>{i18n.language === "fr" ? "Description du projet en français*" : "Project description in French*"}</BoldBlue>
                    <Textarea required name="description_francais" style={{ width: '100%'}} placeholder={i18n.language === "fr" ? "Description du projet en français" : "Project description in French"} defaultValue={currentlyEditingProject?.aboutfr} />
                    <br/><br/>
                    <BoldBlue>{i18n.language === "fr" ? "Description du projet en anglais*" : "Project description in English*"}</BoldBlue>
                    <Textarea required name="description_anglais" style={{ width: '100%'}} placeholder={i18n.language === "fr" ? "Description du projet en anglais" : "Project description in English"} defaultValue={currentlyEditingProject?.abouten} />
                    <br/><br/>
                    <AwardsDisplay
                        inputName="awards"
                        awards={awards}
                        setAwards={setAwards}
                    />
                    <br/>
                    <AwardsAdd
                        awards={awards}
                        setAwards={setAwards}
                    />
                    <br/>
                    <PressLinksDisplay
                        inputName="lien_presse"
                        pressLinks={pressLinks}
                        setPressLinks={setPressLinks}
                    />
                    <PressLinksAdd
                        pressLinks={pressLinks}
                        setPressLinks={setPressLinks}
                    />
                    <br/>
                    <BoldBlue>{i18n.language === "fr" ? "Année du projet" : "Project year"}</BoldBlue> {/*//needs to be a select, with years from 2024 to 2036*/}
                    {/* <Input type="number" name="annee_projet" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Année du projet" : "Project year"} defaultValue={currentlyEditingProject.year} /> */}
                    <Select name="annee_projet" style={{width:"100%"}} defaultValue={currentlyEditingProject.year}>
                        <option value="">{i18n.language === "fr" ? "Sélectionnez une année*" : "Select a year*"}</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                        <option value="2028">2028</option>
                        <option value="2029">2029</option>
                        <option value="2030">2030</option>
                        <option value="2031">2031</option>
                        <option value="2032">2032</option>
                        <option value="2033">2033</option>
                        <option value="2034">2034</option>
                        <option value="2035">2035</option>
                        <option value="2036">2036</option>
                    </Select>
                    <br/>
                    <i>{i18n.language === "fr" ? "Année minimum : 2024" : "Minimum year: 2024"}</i>
                    <br/><br/>
                    <BoldBlue>{i18n.language === "fr" ? "Type de projet*" : "Project type*"}</BoldBlue><br/>
                    <Select name="type" style={{width:"100%"}} defaultValue={currentlyEditingProject.type} onChange={(event) => setType(event.target.value)}>
                        <option value="">{i18n.language === "fr" ? "Sélectionnez un type de projet" : "Select a project type"}</option>
                        <option value="objet">{i18n.language === "fr" ? "Objet" : "Object"}</option>
                        <option value="espace">{i18n.language === "fr" ? "Espace" : "Space"}</option>
                    </Select>
                    <br/><br/>
                    {type === "objet" && <>
                        <BoldBlue>{i18n.language === "fr" ? "S'agit-il d'une seule pièce ou d'une collection ? *" : "Is it a single piece or a collection? *"}</BoldBlue>
                        <Select name="unique_collection" style={{width:"100%"}} defaultValue={currentlyEditingProject.unique_collection}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                            <option value="unique">{i18n.language === "fr" ? "Pièce unique" : "Single piece"}</option>
                            <option value="collection">{i18n.language === "fr" ? "Collection" : "Collection"}</option>
                        </Select>
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Typologie*" : "Typology*"}</BoldBlue>
                        <Select name="typologie" style={{width:"100%"}} defaultValue={currentlyEditingProject.typologie} onChange={(event) => setTypologie(event.target.value)}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie" : "Select a typology"}</option>
                            {typologieObjetFD100.map((option) => {
                                return <option key={option.value} value={option.value}>{option.label}</option>
                            })}
                        </Select>
                        {typologie === "autre" && 
                            <Input required name="autre_typologie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Veuillez préciser" : "Please specify"}  defaultValue={currentlyEditingProject.autre_typologie}/>
                        }
                        <br/><br/>
                        {typologie === "assise" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Assise*" : "Seating*"}</BoldBlue>
                            <Select name="typologieAssise" style={{width:"100%"}} defaultValue={currentlyEditingProject.typologieAssise}>
                                <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie d'assise" : "Select a seating typology"}</option>
                                {typologieAssiseFD100.map((option) => {
                                    return <option key={option.value} value={option.value}>{option.label}</option>
                                })}
                            </Select>
                            <br/><br/>
                        </>}
                        {typologie === "table" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Table*" : "Table*"}</BoldBlue>
                            <Select name="typologieTable" style={{width:"100%"}} defaultValue={currentlyEditingProject.typologieTable}>
                                <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie de table" : "Select a table typology"}</option>
                                {typologieTableFD100.map((option) => {
                                    return <option key={option.value} value={option.value}>{option.label}</option>
                                })}
                            </Select>
                            <br/><br/>
                        </>}
                        {typologie === "luminaire" && <>
                            <BoldBlue>{i18n.language === "fr" ? "Luminaire*" : "Lighting*"}</BoldBlue>
                            <Select name="typologieLuminaire" style={{width:"100%"}} defaultValue={currentlyEditingProject.typologieLuminaire}>
                                <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie de luminaire" : "Select a lighting typology"}</option>
                                {typologieLuminaireFD100.map((option) => {
                                    return <option key={option.value} value={option.value}>{option.label}</option>
                                })}
                            </Select>
                            <br/><br/>
                        </>}
                        <BoldBlue>{i18n.language === "fr" ? "Echelle de production de votre pièce/collection*" : "Production scale of your piece/collection*"}</BoldBlue>
                        <Select name="echelle_production" style={{width:"100%"}} defaultValue={currentlyEditingProject.echelle_production}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une échelle de production" : "Select a production scale"}</option>
                            <option value="industrielle">{i18n.language === "fr" ? "Industrielle" : "Industrial"}</option>
                            <option value="edition_limitee">{i18n.language === "fr" ? "Edition limitée" : "Limited edition"}</option>
                            <option value="piece_unique">{i18n.language === "fr" ? "Pièce unique" : "Single piece"}</option>
                        </Select>
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Nom de l'éditeur*" : "Publisher name*"}</BoldBlue>
                        <Input required name="editeur" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom de l'éditeur" : "Publisher name"} defaultValue={currentlyEditingProject.editeur} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Nom du distributeur*" : "Distributor name*"}</BoldBlue>
                        <Input required name="distributeur" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom du distributeur" : "Distributor name"} defaultValue={currentlyEditingProject.distributeur} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Pays de distribution*" : "Distribution country*"}</BoldBlue>
                        <Select name="pays_distribution" style={{width:"100%"}} defaultValue={currentlyEditingProject.pays_distribution}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez un pays de distribution" : "Select a distribution country"}</option>
                            <option value="europe">{i18n.language === "fr" ? "Europe" : "Europe"}</option>
                            <option value="grand_export">{i18n.language === "fr" ? "Grand Export" : "Grand Export"}</option>
                        </Select>
                        <br/><br/>
                    </>}
                    {type === "espace" && <>
                        <BoldBlue>{i18n.language === "fr" ? "Typologie*" : "Typology*"}</BoldBlue>
                        <Select name="typologie" style={{width:"100%"}} defaultValue={currentlyEditingProject.typologie}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une typologie" : "Select a typology"}</option>
                            {tyoplogieEspaceFD100.map((option) => {
                                return <option key={option.value} value={option.value}>{option.label}</option>
                            })}
                        </Select>
                        {typologie === "autre" && 
                            <Input required name="autre_typologie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Veuillez préciser" : "Please specify"}  defaultValue={currentlyEditingProject.autre_typologie}/>
                        }
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Adresse du projet *" : "Project address*"}</BoldBlue>
                        {/* <Input required name="adresse" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Adresse du projet" : "Project address"} defaultValue={currentlyEditingProject.adresse} /> */}
                        <AdressInput 
                            adressDefaultValue={currentlyEditingProject.adresse}
                            latitudeDefaultValue={currentlyEditingProject.latitude}
                            longitudeDefaultValue={currentlyEditingProject.longitude}
                            required
                            placeholder={i18n.language === "fr" ? "Adresse du projet" : "Project address"}
                            adressInputName="adresse"
                            latitutdeInputName="latitude"
                            longitudeInputName="longitude"
                        />
                        <i style={{color:"red"}}>{i18n.language === "fr" ? "Les projets situés en France ne sont pas éligibles." : "Projects located in France are not eligible."}</i>
                        <br/><br/>
                    </>}
                    <BoldBlue>{i18n.language === "fr" ? "Votre projet fait-il appel à la fabrication française ?*" : "Does your project involve French manufacturing?*"}</BoldBlue>
                    <Select name="fabrication_fr" style={{width:"100%"}} defaultValue={currentlyEditingProject.fabrication_fr} onChange={(event) => setFabrication_fr(event.target.value)}>
                        <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                        <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                        <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                    </Select>
                    <br/>
                    <i style={{color:"red"}}>{i18n.language === "fr" ? "Les précisions apportées par le Candidat sur les savoirs faire ou fabrications françaises qu’implique le projet seront valorisées lors de la sélection." : "The details provided by the Candidate on the French know-how or manufacturing involved in the project will be valued during the selection."}</i>
                    <br/><br/>
                    {shouldAddFabricants() && <>
                        {/* <BoldBlue>{i18n.language === "fr" ? "Nom du fabricant 1" : "Manufacturer 1 name"}</BoldBlue>
                        <Input name="fabricant1" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom du fabricant 1" : "Manufacturer 1 name"} defaultValue={currentlyEditingProject.fabricant1} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Travail réalisé sur le projet par ce fabricant 1" : "Work done on the project by this manufacturer 1"}</BoldBlue>
                        <Input name="travail_fabricant1" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Travail réalisé sur le projet par ce fabricant 1" : "Work done on the project by this manufacturer 1"} defaultValue={currentlyEditingProject.travail_fabricant1} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Contact du fabricant 1" : "Manufacturer 1 contact"}</BoldBlue>
                        <Input name="contact_fabricant1" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Contact du fabricant 1" : "Manufacturer 1 contact"} defaultValue={currentlyEditingProject.contact_fabricant1} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Email du fabricant 1" : "Email of manufacturer 1"}</BoldBlue>
                        <Input name="email_fabricant1" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Email du fabricant 1" : "Email of manufacturer 1"} defaultValue={currentlyEditingProject.email_fabricant1} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Nom du fabricant 2" : "Manufacturer 2 name"}</BoldBlue>
                        <Input name="fabricant2" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Nom du fabricant 2" : "Manufacturer 2 name"} defaultValue={currentlyEditingProject.fabricant2} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Travail réalisé sur le projet par ce fabricant 2" : "Work done on the project by this manufacturer 2"}</BoldBlue>
                        <Input name="travail_fabricant2" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Travail réalisé sur le projet par ce fabricant 2" : "Work done on the project by this manufacturer 2"} defaultValue={currentlyEditingProject.travail_fabricant2} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Contact du fabricant 2" : "Manufacturer 2 contact"}</BoldBlue>
                        <Input name="contact_fabricant2" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Contact du fabricant 2" : "Manufacturer 2 contact"} defaultValue={currentlyEditingProject.contact_fabricant2} />
                        <br/><br/>
                        <BoldBlue>{i18n.language === "fr" ? "Email du fabricant 2" : "Email of manufacturer 2"}</BoldBlue>
                        <Input name="email_fabricant2" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Email du fabricant 2" : "Email of manufacturer 2"} defaultValue={currentlyEditingProject.email_fabricant2} /> */}
                        <FabricantsDisplay
                            inputName="fabricants"
                            fabricants={fabricants}
                            setFabricants={setFabricants}
                        />
                        <FabricantsAdd
                            fabricants={fabricants}
                            setFabricants={setFabricants}
                            required
                        />
                        {(!fabricants || JSON.parse(fabricants).length === 0) && <i style={{color:"red"}}>{i18n.language === "fr" ? "Vous devez ajouter au moins un fabricant." : "You must add at least one manufacturer."}</i>}
                        <br/><br/>
                    </>}
                    {type === "objet" && <BoldBlue>{i18n.language === "fr" ? "Ajoutez au moins 5 fichiers et leurs crédits photos*" : "Add at least 5 files and their photo credits*"}</BoldBlue>}
                    {type === "espace" && <BoldBlue>{i18n.language === "fr" ? "Ajoutez au moins 8 fichiers et leurs crédits photos*" : "Add at least 8 files and their photo credits*"}</BoldBlue>}
                    <br/><br/>
                    <MiniatureContainer>
                        {currentlyEditingProject.medias && currentlyEditingProject.medias.map((media,index) => {
                            return (
                                <MediaPreview key={media.path} media={media} removeMedia={removeOldMedia}/>
                            )
                        })}
                        {newMedias.map((media,index) => {
                            return (
                                <MediaPreview key={index} media={media} newMedia removeMedia={removeNewMedia}/>
                            )
                        })}
                        <AddMedia
                            medias={newMedias}
                            setMedias={setNewMedias}
                        />
                    </MiniatureContainer>

                    {fabrication_fr === "oui" && <>
                        <BoldBlue>{i18n.language === "fr" ? "Autorisez vous Le FRENCH DESIGN à communiquer sur les fabricants qui ont travaillé sur votre projet? *" : "Do you authorize Le FRENCH DESIGN to communicate about the manufacturers who worked on your project? *"}</BoldBlue>
                        <Select name="communiquer_fabricants" style={{width:"100%"}} defaultValue={currentlyEditingProject.communiquer_fabricants}>
                            <option value="">{i18n.language === "fr" ? "Sélectionnez une option" : "Select an option"}</option>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>
                        <br/>
                    </>}

                    <div className="flexblock" style={{marginTop:"20px"}}>
                        <span>{i18n.language === "fr" ? "J'autorise Le FRENCH DESIGN by VIA à rendre public ce projet dans mon portfolio auprès des différents membres de la communauté* :" : "I authorize Le FRENCH DESIGN by VIA to make this project public in my portfolio to the various members of the community*:"}</span>
                        <CheckboxPublicPrivate name="public" defaultChecked={currentlyEditingProject.public ? "on" : "off"}/>
                    </div>
                    <div className="flexblock" style={{marginTop:"20px"}}>
                        <span>{i18n.language === "fr" ? "Je certifie avoir l’autorisation de communiquer sur le projet au moment de la révélation du prix soit à partir de décembre 2025* :" : "I certify that I have permission to communicate about the project at the time of the prize announcement, starting from December 2025*:"}</span>
                        <Checkbox name="autorisation" defaultChecked={true} style={{flexGrow:"0"}}/>
                    </div><br/>

                    {/* hidden projectid field */}
                    <input type="hidden" name="id_in_participation" value={currentlyEditingProject.id_in_participation} />
                    <input type="hidden" name="id_in_company" value={currentlyEditingProject.id_in_company || currentlyEditingProject._id} />
                    <br/><br/>
                    <div className="flexblock">
                        <BlueButton type="button" style={{padding:"12px 20px"}} onClick={()=>setCurrentlyEditingProject(null)}>
                            {i18n.language === "fr" ? "Annuler" : "Cancel"}
                        </BlueButton>
                        <BlueButton type="button" style={{padding:"12px 20px"}} onClick={()=>commitCurrentProject()}>
                            {i18n.language === "fr" ? "Valider" : "Validate"}
                        </BlueButton>
                    </div>
                </div>
            </Popup>
        }
    </>);
}

export default Step2;

const FileContainer = styled.div`
    width: 400px;

    @media (max-width: 1000px) {
        width: 300px;
    }

    .mainMedia {
        width: 100%;
        height: 400px;
        border: 1px solid black;
        display: flex;
        justify-content: center;
        align-items: center;
        position : relative;

        @media (max-width: 1000px) {
            height: 300px;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .remove_cross{
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: red;
            color: white;
            font-size: 20px;
            border-radius: 100px;
            padding: 2px 7px;
            opacity: 0;
            cursor: pointer;
            z-index: 2;
        }

        &:hover .remove_cross {
            opacity: 0.5;

            &:hover {
                opacity: 1;
            }
        }
    }

    .addMedia {
        width: 100%;
        height: 400px;

        @media (max-width: 1000px) {
            height: 300px;
        }

        background-image: linear-gradient(#fff, #bbb);
        cursor: pointer;
        color: white;
        
        div {
            padding: 40px;
            display: flex;
            justify-content: center;
            align-items: end;
            height: 100%;
            background-image: url('/img/croix_blanche.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 30px;
        }
    }
`

const MediaPreview = (props) => {

    const { i18n } = useTranslation('common');

    let file = {}
    if(props.newMedia)
        file = props.media.file;
    else
        file = props.media;

    if(!file || !file.type) return null;

    let fullPath = '';
    let fileName = '';
    let credit = '';
    // let legende = '';
    if(props.newMedia){
        fullPath = URL.createObjectURL(file);
        fileName = file.name;
        credit = props.media.credit;
        // legende = props.media.legende;
    }else{
        fullPath = process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.path;
        fileName = file.fileName;
        credit = file.credit;
        // legende = file.legende;
    }

    function removeMedia(){
       props.removeMedia(props.media);
    }

    return (
        <FileContainer>
            <div className="mainMedia">
                <span className="remove_cross" onClick={removeMedia}>✕</span>
                {file.type.includes('image') && <img src={fullPath} alt={fileName}/>}
                {file.type.includes('video') && <video controls >
                    <source src={fullPath} type={file.type}/>
                </video>}
                {file.type.includes('pdf') &&  <a href={fullPath} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Voir le PDF" : "See PDF"}</a>}
            </div>
            <br/>
            <i>{fileName}</i><br/><br/>
            <span>{i18n.language === "fr" ? "Credit" : "Copyright"} : <span>{credit}</span></span><br/>
            {/* <span>{i18n.language === "fr" ? "Légende" : "Caption"} : <span>{legende}</span></span><br/> */}
        </FileContainer>
    )
}

const AddMedia = (props) => {

    const { i18n } = useTranslation('common');
    const [popupOpen, setPopupOpen] = React.useState(false);
    const [currentFile, setCurrentFile] = React.useState(null);
    const [credit, setCredit] = React.useState('');
    const [legende, setLegende] = React.useState('');
    const fileInputRef = useRef(null);

    const handleInputChange = (event) => {

        if(event.target.files[0] && event.target.files[0].size > 50000000){
            api.LogFront("User tried to upload a file over 50Mo in fd100 2025, filesize : " + (event.target.files[0].size / 1000000) + "Mo");
            alert(i18n.language === "fr" ? "Le fichier est trop lourd. Veuillez sélectionner un fichier de moins de 50Mo." : "The file is too heavy. Please select a file under 50Mb.");
            return;
        }

        console.log("event.target.files[0]", event.target.files[0]);

        setCurrentFile(event.target.files[0]);
    };

    const handleAddFile = (event) => {
        event.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Trigger the file selection popup
        }
    };

    const changeCreditInput = (event) => {
        setCredit(event.target.value);
    };

    function addMedia(event){
        event.preventDefault();

        //check if the credit is not empty
        if(credit === ''){
            alert(i18n.language === "fr" ? "Veuillez renseigner le crédit de la photo." : "Please provide the photo credit.");
            return;
        }

        setPopupOpen(false);
        props.setMedias([...props.medias, {file:currentFile,credit,legende}]);
        setCurrentFile(null);
        setCredit('');
        setLegende('');

        //aslo clear the input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    return (
        <>
            <FileContainer>
                <div style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)} className="addMedia">
                    <div>{i18n.language === 'fr' ? "Ajouter un média" : "Add a media"}</div>
                </div>
                <input hidden type='file' accept="application/pdf, image/png, image/jpeg, video/mp4, video/quicktime" onChange={handleInputChange} ref={fileInputRef}/>
                <input hidden readOnly value={credit}/>
                <input hidden readOnly value={legende}/>
                {popupOpen &&
                    <Popup close={() => setPopupOpen(false)}>
                        {currentFile ? (
                            <>
                                <span>{i18n.language === 'fr' ? ("Fichier sélectionnée :") : ("Selected file:")}</span><br/>
                                <span><a href={URL.createObjectURL(currentFile)} target="_blank" rel="noreferrer">{i18n.language === 'fr' ? 'Voir le fichier' : 'View file'}</a></span><br/>
                                <button onClick={event => handleAddFile(event)}>{i18n.language === 'fr' ? 'Sélectionner un autre fichier' : 'Select another file'}</button><br/>
                            </>
                        ) : (
                            <>
                                <span>{i18n.language === 'fr' ? ("Pas de fichier sélectionné.") : ("No file selected.")}</span><br/>
                                <button onClick={event => handleAddFile(event)}>{i18n.language === 'fr' ? 'Sélectionner un fichier' : 'Select a file'}</button><br/>
                            </>      
                        )}
                        <span className='thin'>{i18n.language === "fr" ? "(.mp4, .pdf, .png, .jpg ou .jpeg, 50Mo maximum)" : "(.mp4, .pdf, .png, .jpg or .jpeg, 50Mb maximum)"}</span><br/>
                        <Input style={{width:"100%"}} required onChange={changeCreditInput} placeholder={i18n.language === "fr" ? "Crédit" : "Copyright"} defaultValue={credit} /><br/>
                        {currentFile && <button onClick={addMedia}>{i18n.language === 'fr' ? 'Ajouter' : 'Add'}</button>}
                    </Popup>
                }
            </FileContainer>
        </>
    )
}